<template>
  <div class="content-tag-select">
    <div class="tag-box">
      <span v-if="!value.length" class="placeholder">未添加标签</span>
      <span v-for="tag in value" :key="tag.tagId" class="tag-chip">
        <span class="tag-name">{{ tag.tagName }}</span>
        <button type="button" class="tag-remove" @click="removeTag(tag)">×</button>
      </span>
    </div>
    <el-popover
      ref="popover"
      placement="bottom-end"
      trigger="click"
      :width="360"
      popper-class="content-tag-popover"
      @show="onPopoverShow"
    >
      <div class="tag-picker">
        <ul class="type-list">
          <li
            v-for="type in types"
            :key="type.value"
            :class="{ active: String(activeTypeId) === String(type.value) }"
            @click="selectType(type)"
          >{{ type.label }}</li>
          <li v-if="!types.length" class="empty">暂无分类</li>
        </ul>
        <ul class="tag-list">
          <li v-if="loadingTags" class="empty">加载中</li>
          <li v-else-if="!activeTypeId" class="empty">请先选择分类</li>
          <li v-else-if="!tagOptions.length" class="empty">暂无标签</li>
          <li
            v-for="tag in tagOptions"
            :key="tag.value"
            :class="{ disabled: isSelected(tag.value) }"
            @click="addTag(tag)"
          >{{ tag.label }}</li>
        </ul>
      </div>
      <button slot="reference" type="button" class="add-tag-btn" :disabled="value.length >= 10">
        添加标签
      </button>
    </el-popover>
  </div>
</template>

<script>
import { getTagList, getTagType } from '@/servies/index.js';

const tagCache = {
  types: null,
  typesPending: null,
  tags: {},
};

function fetchTagTypes() {
  if (tagCache.types) return Promise.resolve(tagCache.types);
  if (!tagCache.typesPending) {
    tagCache.typesPending = getTagType({})
      .then((response) => {
        const types =
          response.data &&
          response.data.code === 200 &&
          response.data.data &&
          response.data.data.contentTagTypes
            ? response.data.data.contentTagTypes
            : [];
        tagCache.types = types.map((item) => ({
          value: item.tagTypeId,
          label: item.tagTypeName,
        }));
        return tagCache.types;
      })
      .catch((error) => {
        tagCache.typesPending = null;
        return Promise.reject(error);
      });
  }
  return tagCache.typesPending;
}

function fetchTags(tagTypeId) {
  const key = String(tagTypeId);
  if (tagCache.tags[key]) return Promise.resolve(tagCache.tags[key]);
  return getTagList({ tagTypeId }).then((response) => {
    const tags =
      response.data &&
      response.data.code === 200 &&
      response.data.data &&
      response.data.data.contentTags
        ? response.data.data.contentTags
        : [];
    tagCache.tags[key] = tags.map((tag) => ({
      value: tag.tagId,
      label: tag.tagName,
    }));
    return tagCache.tags[key];
  });
}

export default {
  name: 'ContentTagSelect',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      types: [],
      activeTypeId: '',
      tagOptions: [],
      loadingTags: false,
    };
  },
  methods: {
    onPopoverShow() {
      fetchTagTypes()
        .then((list) => {
          this.types = list;
        })
        .catch(() => {
          this.$message.error('标签分类加载失败');
        });
    },
    selectType(type) {
      this.activeTypeId = type.value;
      if (tagCache.tags[String(type.value)]) {
        this.tagOptions = tagCache.tags[String(type.value)];
        return;
      }
      this.loadingTags = true;
      this.tagOptions = [];
      fetchTags(type.value)
        .then((list) => {
          if (String(this.activeTypeId) !== String(type.value)) return;
          this.tagOptions = list;
        })
        .catch(() => {
          this.$message.error('标签加载失败');
        })
        .finally(() => {
          this.loadingTags = false;
        });
    },
    isSelected(tagId) {
      return this.value.some((tag) => String(tag.tagId) === String(tagId));
    },
    addTag(tag) {
      if (this.isSelected(tag.value)) {
        this.$message.error('该标签已存在，请选择其他标签');
        return;
      }
      if (this.value.length >= 10) {
        this.$message.error('只可选择10个标签');
        return;
      }
      this.$emit(
        'input',
        this.value.concat([
          {
            tagId: tag.value,
            tagName: tag.label,
          },
        ])
      );
      if (this.$refs.popover) this.$refs.popover.doClose();
    },
    removeTag(tag) {
      this.$emit(
        'input',
        this.value.filter((item) => String(item.tagId) !== String(tag.tagId))
      );
    },
  },
};
</script>

<style lang="less" scoped>
.content-tag-select {
  display: flex;
  align-items: center;
  width: 100%;
  .tag-box {
    flex: 1;
    min-width: 0;
    min-height: 40px;
    padding: 6px 8px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
    line-height: 24px;
  }
  .placeholder {
    color: #c0c4cc;
    font-size: 14px;
  }
  .tag-chip {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    margin: 2px 6px 2px 0;
    padding: 0 4px 0 8px;
    border-radius: 4px;
    background: rgba(4, 203, 205, 0.12);
    color: #04cbcd;
    font-size: 12px;
    line-height: 24px;
  }
  .tag-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .tag-remove {
    margin-left: 2px;
    padding: 0 4px;
    border: 0;
    background: transparent;
    color: #04cbcd;
    font-size: 14px;
    line-height: 22px;
    cursor: pointer;
  }
  .add-tag-btn {
    flex: none;
    height: 40px;
    margin-left: 8px;
    padding: 0 16px;
    border: 1px solid #04cbcd;
    border-radius: 4px;
    background: #fff;
    color: #04cbcd;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      background: #04cbcd;
      color: #fff;
    }
    &:disabled {
      border-color: #dcdfe6;
      background: #f5f7fa;
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}
</style>

<style lang="less">
.content-tag-popover {
  z-index: 4000 !important;
  padding: 0;
  .tag-picker {
    display: flex;
    height: 240px;
  }
  .type-list,
  .tag-list {
    flex: 1;
    margin: 0;
    padding: 4px 0;
    overflow-y: auto;
    list-style: none;
  }
  .type-list {
    border-right: 1px solid #ebeef5;
  }
  li {
    padding: 8px 12px;
    color: #303133;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    &:hover,
    &.active {
      background: rgba(4, 203, 205, 0.12);
      color: #04cbcd;
    }
    &.empty,
    &.disabled {
      color: #c0c4cc;
      cursor: default;
      background: transparent;
    }
  }
}
</style>
